export const ALLOWED_EDITOR_MODAL = {
	ONBOARDING_EDITOR_MODAL: 'onboarding-editor-modal',
};
